import * as React from "react";

interface ImagePreviewProps {
  text: string;
}

class ImagePreview extends React.Component<ImagePreviewProps, {}> {
  render() {
    const text = this.props.text;
    if (!text) {
      return null;
    }

    const regex = /(?:^(?:(?!src=).)*)(https?|HTTPS?)(:\/\/)(.*\.)(png|PNG|jpg|JPG|jpeg|JPEG|gif|GIF)(?:[^\s]+|\b)/g;
    const matches = regex.exec(text);

    if (!matches || !matches.length || matches.length < 5) {
      return null;
    }

    const url = matches[1] + matches[2] + matches[3] + matches[4];

    return <img src={url} alt="" role="presentation" />;
  }
}

export default ImagePreview;
